"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doDying = doDying;
function doDying(currentTurn, state, board, pieceRegistry, pieceId, { combatStore }) {
    if (state.payload.dieAtTurn <= currentTurn) {
        return [state, [{ type: "delete" }]];
    }
    return [state];
}
